const CircleArrow = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11.5602 8.98123C11.9311 8.67219 12.4697 8.67219 12.8406 8.98123L16.8181 12.2958C17.2424 12.6494 17.2997 13.2799 16.9461 13.7042C16.5926 14.1285 15.962 14.1858 15.5377 13.8323L12.2004 11.0512L8.86308 13.8323C8.43881 14.1858 7.80824 14.1285 7.45468 13.7042C7.10112 13.2799 7.15844 12.6494 7.58272 12.2958L11.5602 8.98123Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default CircleArrow;
